var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_user-agent.js
// module id = uu9M
// module chunks = 0